import { useEffect, useRef, type ReactNode } from "react";

/**
 * Tall booking forms must scroll far enough to reveal Reserve. A fixed top
 * offset otherwise pins their bottom permanently below a short viewport.
 * Keep document scrolling, rather than adding a second scrolling form.
 */
export function CarBookingRail({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const measure = () => node.style.setProperty("--car-booking-rail-height", `${node.getBoundingClientRect().height}px`);
    measure();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(measure);
    observer.observe(node);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className="sticky car-booking-rail" data-testid="car-booking-rail"
    style={{ top: "min(calc(var(--header-h, 4rem) + 2rem), calc(100svh - var(--car-booking-rail-height, 0px) - 1rem))" }}>
    {children}
  </div>;
}
